import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './Button';
import './Drawer.css';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  width?: string;
}

export const Drawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  title,
  children,
  width = '600px',
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setIsClosing(false);
      document.body.style.overflow = 'hidden';
    } else if (isVisible) {
      // Start closing animation
      setIsClosing(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setIsClosing(false);
        document.body.style.overflow = 'unset';
      }, 300); // Match animation duration

      return () => clearTimeout(timer);
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, isVisible]);

  if (!isVisible) return null;

  return (
    <>
      <div
        className={`drawer-overlay ${isClosing ? 'drawer-overlay-closing' : ''}`}
        onClick={onClose}
      />
      <div
        className={`drawer ${isClosing ? 'drawer-closing' : ''}`}
        style={{ width }}
      >
        <div className="drawer-header">
          {title && <h2 className="drawer-title">{title}</h2>}
          <Button
            variant="secondary"
            onClick={onClose}
            className="drawer-close"
          >
            <X size={20} />
          </Button>
        </div>
        <div className="drawer-content">
          {children}
        </div>
      </div>
    </>
  );
};
